/** @typedef {import('./types').Overlay} Overlay */
/** @typedef {import('./types').OverlayDetailsInput} OverlayDetailsInput */
/**
 * @param {...string} [args]
 * @returns {string}
 */
export function buildPath(...args) {
    const [first] = args;
    const firstTrimmed = first.trim();
    const result = args
        .map((part) => part.trim())
        .map((part, i) => {
        if (i === 0) {
            return part.replace(/\/*$/g, "");
        }
        else {
            return part.replace(/^\/*|\/*$/g, "");
        }
    })
        .filter((x) => x.length)
        .join("/");
    return firstTrimmed === "/" ? `/${result}` : result;
}
/**
 * @param {{
 * 	defaults: z.output<z.ZodSchema<ConfigSchema>>;
 * 	details: OverlayDetailsInput;
 * 	schema: z.ZodSchema<ConfigSchema>;
 * }}
 * @returns {Overlay<ConfigSchema>}
 */
export function defineOverlay({ defaults, details, schema, }) {
    return {
        _config: {
            defaults,
            schema,
        },
        category: details.category,
        details: {
            ...details,
            icon: details.icon
                ? buildPath("/node_modules", "/@playlive", "/overlay-config-data", "/icons", details.icon)
                : null,
            pageTitle: details.pageTitle ?? details.name,
            shortDescription: details.shortDescription ?? details.description,
            shortName: details.shortName ?? details.name,
        },
        getDefaultConfig: () => defaults,
        getSchema: () => schema,
        slug: details.slug,
    };
}
/**
 * @param {T} template
 * @returns {T}
 */
export function defineOverlays(template) {
    return template;
}
/**
 * @param {string[]} slugs
 * @param {Record<S, Overlay<unknown>>} mapping
 * @param {string} slugOrKey
 * @returns {Overlay<unknown>}
 */
export function getUnsafeFn(slugs, mapping, slugOrKey) {
    const keys = Object.keys(mapping);
    const all = Object.values(mapping);
    if (keys.includes(slugOrKey)) {
        return mapping[slugOrKey];
    }
    else if (slugs.includes(slugOrKey)) {
        const foundOverlay = all.find((overlay) => overlay.slug === slugOrKey);
        if (foundOverlay) {
            return foundOverlay;
        }
    }
    throw new Error("Invalid slug/key");
}
//# sourceMappingURL=functions.js.map